// src/components/AdminBookingData.js
import React from 'react';
import { CSVLink } from 'react-csv';

const normalizeDate = (dateStr) => {
  if (!dateStr) return '';
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr; // YYYY-MM-DD
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {               // DD-MM-YYYY -> YYYY-MM-DD
    const [dd, mm, yyyy] = dateStr.split('-');
    return `${yyyy}-${mm}-${dd}`;
  }
  return dateStr;
};

const toDateObj = (dateStr) => {
  const n = normalizeDate(dateStr);
  const [y, m, d] = n.split('-').map(Number);
  return new Date(y, (m || 1) - 1, d || 1);
};

// ✅ Formatter: YYYY-MM-DD → 16 Aug 2025
const formatDisplayDate = (dateStr) => {
  const dateObj = toDateObj(dateStr);
  if (isNaN(dateObj)) return dateStr; // fallback
  return dateObj.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

const AdminBookingData = ({ bookings, searchQuery, setSearchQuery, handleDelete }) => {
  const sortedDates = Object.keys(bookings || {}).sort(
    (a, b) => toDateObj(b) - toDateObj(a)
  );

  const selectedDate = normalizeDate(searchQuery?.trim());
  const visibleDates = selectedDate
    ? sortedDates.filter((d) => normalizeDate(d) === selectedDate)
    : sortedDates;

  const visibleRows = visibleDates.flatMap((dateKey) => bookings[dateKey] || []);

  return (
    <>
      <div className="search-controls">
        <input
          type="date"
          value={selectedDate || ''}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-bar"
        />
        {selectedDate && (
          <button
            type="button"
            className="clear-date-btn"
            onClick={() => setSearchQuery('')}
            style={{ marginLeft: 8 }}
          >
            Clear
          </button>
        )}
        <CSVLink
          data={visibleRows}
          filename={
            selectedDate
              ? `snooker-bookings-${selectedDate}.csv`
              : 'snooker-bookings.csv'
          }
          className="export-btn"
        >
          Export to CSV
        </CSVLink>
      </div>

      <div className="booking-list">
        {visibleDates.map((date) => {
          const bookingList = bookings[date] || [];
          if (!bookingList.length) return null;

          return (
            <div key={date} className="booking-date-group">
              {/* ✅ Pretty date header */}
              <h3>{formatDisplayDate(date)}</h3>
              <table className="booking-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Table</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {bookingList.map((booking) => (
                    <tr key={booking.id}>
                      <td>{booking.name}</td>
                      <td>{booking.phone}</td>
                      <td>{booking.table}</td>
                      <td>{booking.startTime}</td>
                      <td>{booking.endTime}</td>
                      <td>
                        <button
                          onClick={() => handleDelete(booking.id)}
                          className="delete-btn"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        })}

        {!visibleDates.length && (
          <div className="empty-state">No bookings for the selected date.</div>
        )}
      </div>
    </>
  );
};

export default AdminBookingData;
